/**
 * Kelluva "Varaa sovitus" -painike (snippets/sticky-book.liquid), alle 990 px.
 *
 * Näkyy vain, kun heron varauspainike on ohitettu (alareuna näkymän yläpuolella) JA käyttäjä
 * rullaa ylöspäin (kynnys 8 px). Piilossa alaspäin rullatessa ja aina, kun valikko-drawer tai
 * Slotti-modaali on auki. Tila tarkistetaan myös latauksessa ja resize-tapahtumassa.
 */
(function () {
  const button = document.querySelector('[data-sticky-book]');
  if (!button) return;

  const THRESHOLD = 8;
  const mobile = window.matchMedia('(max-width: 989px)');

  /** Heron varauspainike: [data-hero-book] tai heron osion ensimmäinen #varaa-sovitus-linkki. */
  function findHeroBook() {
    return (
      document.querySelector('[data-hero-book]') ||
      document.querySelector('[id$="__hero"] a[href$="#varaa-sovitus"], [id$="__hero"] [data-slotti]')
    );
  }

  let heroBook = findHeroBook();
  let lastY = window.scrollY;
  let scrollingUp = false;
  let visible = false;
  let ticking = false;

  function overlayOpen() {
    const slotti = document.getElementById('slotti-modal');
    const drawer = document.getElementById('Details-menu-drawer-container');
    return Boolean((slotti && slotti.open) || (drawer && drawer.hasAttribute('open')));
  }

  function heroPassed() {
    if (!heroBook || !heroBook.isConnected) heroBook = findHeroBook();
    // Sivuilla ilman heroa painike näytetään, kun on rullattu yli näkymän korkeuden
    if (!heroBook) return window.scrollY > window.innerHeight;
    return heroBook.getBoundingClientRect().bottom < 0;
  }

  /** @param {boolean} show */
  function setVisible(show) {
    if (show === visible) return;
    visible = show;
    button.classList.toggle('is-visible', show);
    if (show) {
      button.removeAttribute('aria-hidden');
      button.removeAttribute('tabindex');
    } else {
      button.setAttribute('aria-hidden', 'true');
      button.setAttribute('tabindex', '-1');
      if (document.activeElement === button) button.blur();
    }
  }

  function update() {
    ticking = false;

    const y = window.scrollY;
    const delta = y - lastY;
    if (Math.abs(delta) >= THRESHOLD) {
      scrollingUp = delta < 0;
      lastY = y;
    }

    setVisible(mobile.matches && scrollingUp && heroPassed() && !overlayOpen());
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  /** Lataus, palautettu scroll, ankkurit ja koon muutos: suunta nollataan, tila lasketaan uudelleen. */
  function reset() {
    lastY = window.scrollY;
    scrollingUp = false;
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', reset, { passive: true });
  window.addEventListener('pageshow', reset);
  window.addEventListener('hashchange', reset);
  mobile.addEventListener('change', reset);

  // Valikko ja Slotti: piilotetaan heti avattaessa
  const observer = new MutationObserver(requestUpdate);
  const watch = () => {
    for (const id of ['slotti-modal', 'Details-menu-drawer-container']) {
      const element = document.getElementById(id);
      if (element) observer.observe(element, { attributes: true, attributeFilter: ['open'] });
    }
  };
  watch();
  document.addEventListener('DOMContentLoaded', watch);

  reset();
})();
